import type { Dayjs } from "dayjs";
import { businessDayOfMonth } from "@/helpers/time";

export const ENROLLMENT_CUTOFF_DAY = 15;

export const enrollmentCutoffDate = (today: Dayjs): Dayjs =>
  businessDayOfMonth(today, ENROLLMENT_CUTOFF_DAY);

export const isEnrolledThisMonth = (today: Dayjs): boolean =>
  !today.isAfter(enrollmentCutoffDate(today), "day");
